import React from 'react';
import { Outlet } from 'react-router-dom';

const ManufacturingMngPage = () => {
  return <Outlet />;
};

export default ManufacturingMngPage;
